export const EHRInstallation_TypeLabelMap = {
    epic: 'Epic',
    cerner: 'Cerner',
    deploy: 'Deploy'
};
//# sourceMappingURL=consts.js.map